export default {
    methods: {
        isDescendant( child, parent )
        {
            // https://htmldom.dev/check-if-an-element-is-a-descendant-of-another/

            let node = child.parentNode;
            while( node )
            {
                if( node === parent )
                {
                    return true;
                }

                // Traverse up to the parent
                node = node.parentNode;
            }

            // Go up until the root but couldn't find the `parent`
            return false;
        }
    }
};
